














import { Component, Mixins, Prop } from "vue-property-decorator";

@Component({
})
export default class IdentifierViewer extends Mixins() {
  @Prop()
  source: any;

  get id(): string {
    return (!this.source || !this.source.id)
      ? "--"
      : this.source.id.toString();
  }

  get name(): string {
    if (this.source && this.source.displayName) {
      return this.source.displayName;
    }
    return (!this.source || !this.source.name)
      ? ""
      : this.source.name;
  }
}
